import { wrapSyncFunc } from '../util';
export var regexp = wrapSyncFunc(function (rule, value) {
  var regexp = rule.regexp;

  if (regexp == null) {
    return;
  }

  if (typeof value === 'string' && value !== '') {
    var reg = typeof regexp === 'string' ? new RegExp(regexp) : regexp;
    return reg.test(value);
  }
});